export default {
  appointment: 'appointment',
  at: 'in',
  back: 'back',
  closed: 'closed',
  emergency: 'emergency',
  'except-kids': 'not available for children',
  'except-treatment': 'treatment not available',
  for: 'for',
  form: {
    fields: {
      firstName: 'first name',
      lastName: 'last name',
      phone: 'phone',
      email: 'e-mail',
    },
    validation: {
      firstName: {
        required: 'first name is required',
      },
      lastName: {
        required: 'last name is required',
      },
      phone: {
        required: 'phone is required',
      },
      email: {
        required: 'e-mail is required',
        email: 'enter a valid e-mail',
      },
    },
  },
  'i-am-a-new-patient': 'i am a new patient',
  'i-wish': 'i\'d like to consult',
  infos: 'info',
  message: 'message',
  'my-appointment-in': 'my appointment in',
  'my-appointment-for': 'my appointment for',
  no: 'no',
  open: 'open',
  personTypes: {
    adult: 'an adult (from 18 y.o.)',
    kid: 'a child (up to 15 y.o.)',
    teenager: 'a teenager (16-18 y.o.)',
  },
  send: 'send',
  step4: {
    infos: 'By clicking on "Send", you send us your appointment request. Add a comment here if you wish (for example a preferred schedule, the name of a dentist you wish to have for your treatment or any other useful information for your appointment request',
    'see-you-soon': 'see you soon',
    signature: 'Team Adent',
    'thank-you': 'We have received your message. We will contact you shortly to suggest an appointment according to your request. See you soon!',
    'you-can-leave': 'You can leave this window now.',
  },
  'take-appointment': 'book an appointment',
  'there-for-you': 'we are here for you',
  where: 'where',
  yes: 'yes',
}
